import { Box, Card, Flex, HStack, VStack } from '@televet/kibble-ui';
import { Heading } from '@televet/kibble-ui/build/components/Heading';
import { Icon } from '@televet/kibble-ui/build/components/Icon';
import { Tag } from '@televet/kibble-ui/build/components/Tag';
import { Text } from '@televet/kibble-ui/build/components/Text';
import { default as React } from 'react';
import { AppointmentData } from '../types/AppointmentData';

type AppointmentListItemProps = {
  appointmentData: AppointmentData;
  onClick: () => void;
};

export const AppointmentListItem = ({ appointmentData, onClick }: AppointmentListItemProps): JSX.Element => {
  return (
    <Card mb={4} p={0} onClick={onClick} isInteractive={true}>
      <HStack p={3} spacing={2} alignItems="flex-start" justify="space-between" align="baseline">
        <Icon name="calendarCheck" size="lg" />
        <VStack justify="center" align="left" spacing={0} flexGrow={1}>
          <Box mt={1} mb={2}>
            <Heading size="xs" mb={1}>
              {appointmentData.title}
            </Heading>
            <Text size="sm" variant="subtle">
              {appointmentData.startsAtStr}
            </Text>
          </Box>
          <Flex gap={2}>
            <Tag
              label={appointmentData.doctor}
              variant="info"
              leftElement={<Icon name="person" size="xs" color="text.info" />}
              size="sm"
            />
            <Tag
              label={appointmentData.duration}
              variant="info"
              leftElement={<Icon name="clock" size="xs" color="text.info" />}
              size="sm"
            />
          </Flex>
        </VStack>
      </HStack>
    </Card>
  );
};
